exports.components = {
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-contact-js": () => import("./../../../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-fruit-js": () => import("./../../../src/pages/fruit.js" /* webpackChunkName: "component---src-pages-fruit-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-plantation-js": () => import("./../../../src/pages/plantation.js" /* webpackChunkName: "component---src-pages-plantation-js" */)
}

